import { Data, Schema } from 'effect'

export const wowheelNotes = Data.array([
  'Rhubarb',
  'Red Apple',
  'Green Apple',
  'Pear',
  'Grapes',
  'Plum',
  'Peach',
  'Apricot',
  'Melon',
  'Papaya',
  'Passion Fruit',
  'Mango',
  'Pineapple',
  'Banana',
  'Kiwi',
  'Lychee',
  'Coconut',
  'Prune',
  'Raisin',
  'Dates',
  'Fig',
  'Honey',
  'White Sugar',
  'Vanilla',
  'Marzipan',
  'Maple Syrup',
  'Molasses',
  'Caramel',
  'Dark Chocolate',
  'Milk Chocolate',
  'Almond',
  'Hazelnut',
  'Pistachio',
  'Winey',
  'Tomato',
  'Boozy',
  'Cardamom',
  'Ginger',
  'Coriander',
  'Cinnamon',
  'Star Anise',
  'Clove',
  'Nutmeg',
  'Liquorice',
  'Artemisia Abrotanum var. Maritima',
  'Lemongrass',
  'Thyme',
  'Sage',
  'Rosemary',
  'Mint',
  'Hops',
  'Hmmm... tastes so... familiar',
  'Lavender',
  'Rose',
  'Hibiscus',
  'Jasmine',
  'Elderflower',
  'Camomile',
  'Black Tea',
  'Green Tea',
  'Bergamot',
  'Redcurrant',
  'Rose Hip',
  'Strawberry',
  'Raspberry',
  'Cranberry',
  'Cherry',
  'Blueberry',
  'Blackberry',
  'Blackcurrant',
  'Lemon',
  'Lime',
  'Yuzu',
  'Grapefruit',
  'Orange',
  'Mandarin',
] as const)

export const WowheelNote = Schema.Literal(...wowheelNotes)
export type WowheelNote = typeof WowheelNote.Type

export const InnerRings = Schema.Struct({
  'Common Fruits': Schema.Array(WowheelNote).pipe(Schema.itemsCount(9)),
  'Tropical Fruits': Schema.Array(WowheelNote).pipe(Schema.itemsCount(8)),
  'Dried Fruits': Schema.Array(WowheelNote).pipe(Schema.itemsCount(4)),
  'Sweets': Schema.Array(WowheelNote).pipe(Schema.itemsCount(7)),
  'Chocolate and Nuts': Schema.Array(WowheelNote).pipe(Schema.itemsCount(5)),
  'Savoury and Ferment': Schema.Array(WowheelNote).pipe(Schema.itemsCount(3)),
  'Spices': Schema.Array(WowheelNote).pipe(Schema.itemsCount(8)),
  'Herbs': Schema.Array(WowheelNote).pipe(Schema.itemsCount(7)),
  'Familiar': Schema.Array(WowheelNote).pipe(Schema.itemsCount(1)),
  'Florals': Schema.Array(WowheelNote).pipe(Schema.itemsCount(9)),
  'Berries': Schema.Array(WowheelNote).pipe(Schema.itemsCount(9)),
  'Citrus Fruits': Schema.Array(WowheelNote).pipe(Schema.itemsCount(6)),
})

export const innerRings = InnerRings.make({
  'Common Fruits': wowheelNotes.slice(0, 9),
  'Tropical Fruits': wowheelNotes.slice(9, 17),
  'Dried Fruits': wowheelNotes.slice(17, 21),
  'Sweets': wowheelNotes.slice(21, 28),
  'Chocolate and Nuts': wowheelNotes.slice(28, 33),
  'Savoury and Ferment': wowheelNotes.slice(33, 36),
  'Spices': wowheelNotes.slice(36, 44),
  'Herbs': wowheelNotes.slice(44, 51),
  'Familiar': wowheelNotes.slice(51, 52),
  'Florals': wowheelNotes.slice(52, 61),
  'Berries': wowheelNotes.slice(61, 70),
  'Citrus Fruits': wowheelNotes.slice(70, 76),
})
